import { render, staticRenderFns } from "./otherModal.vue?vue&type=template&id=b38e6d32&scoped=true&"
import script from "./otherModal.vue?vue&type=script&lang=js&"
export * from "./otherModal.vue?vue&type=script&lang=js&"
import style0 from "./otherModal.vue?vue&type=style&index=0&id=b38e6d32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38e6d32",
  null
  
)

export default component.exports